import { createContextStore } from '@/shared/util/createContextStore';

export type DocsLayoutState = {
  openDrawer: boolean;
};

export type DocsLayoutAction = {
  setOpenDrawer: (open: boolean) => void;
};

const [DocsLayoutStoreProvider, useDocsLayoutStore] = createContextStore<
  DocsLayoutState,
  DocsLayoutAction
>(
  (set) => ({
    openDrawer: false,
    setOpenDrawer: (open) => {
      set((x) => ({
        ...x,
        openDrawer: open,
      }));
    },
  }),
  false,
);

export { DocsLayoutStoreProvider, useDocsLayoutStore };
